
document.addEventListener('DOMContentLoaded', () => {

  document.addEventListener('variant:change', function (event) {
    const variant = event.detail.variant;
    
    if (!variant) return;
    updateProductBadges(variant.id);
  });

  function updateProductBadges(variantId) {
    const container = document.querySelector(".overlay_gallery_badge");
    if (!container) return;

    fetch(`${window.location.pathname}?variant=${variantId}`)
      .then(res => res.text())
      .then(html => {
        const newDoc = new DOMParser().parseFromString(html, 'text/html');
        const newBadges = newDoc.querySelector('.overlay_gallery_badge');

        if (newBadges) {
          container.innerHTML = newBadges.innerHTML;
        }
      });
  }

  window.addEventListener("scroll", function () {
    const header = document.querySelector(".shopify-section--header");

    if (window.scrollY > 0) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  });


// ========================================== Mega_menu BLury =========================

  const megaItems = document.querySelectorAll('.mega_menu_available');

  megaItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
      document.body.classList.add('menu-hover-active');
    });

  });

/* ============================= DYNAMIC HEADER + MOBILE DRAWER============================= */

  $(function () {
    
    var $btn = $('#close_announcement_bar, .close_announcement_bar, [name="close_announcement_bar"]').first();
    if (!$btn.length) return;

    $btn.on('click', function (e) {
      e.preventDefault();
      var $bar = $('.shopify-section--announcement-bar').first();
      if (!$bar.length) return;

      $bar.slideUp(300, function () { 
        $(this).hide();

        console.log("call");
        updateHeaderHeight();
        $('.shopify-section--header').addClass('remove_annoucement');

      });
    });
  });



let announcementHeight = 0;

function setAnnouncementHeight() {

  const announcement = document.querySelector('.shopify-section--announcement-bar');
 
  if (
    announcement &&
    announcement.offsetHeight > 0 &&
    isElementInViewport(announcement)
  ) {
    announcementHeight = announcement.offsetHeight + 10;
  } else {
    announcementHeight = 0;
  }

  document.documentElement.style.setProperty(
    '--announcement-height',
    `${announcementHeight}px`
  );
}

function getDrawerHeight() {
  const drawer = document.querySelector('.new_drawer_layout');
  if (!drawer) return 0;

  const styles = window.getComputedStyle(drawer);

  // Drawer hidden = height must be ignored
  if (
    styles.display === "none" ||
    styles.visibility === "hidden" ||
    drawer.offsetParent === null || 
    drawer.offsetHeight === 0
  ) {
    return 0;
  }

  return drawer.offsetHeight;
}

function updateHeaderHeight() {

  const header = document.querySelector('.new_header_layout');
  const headerHeight = header ? header.offsetHeight : 0;

  setAnnouncementHeight();

  const drawerHeight = window.innerWidth <= 768 ? getDrawerHeight() : 0;
  const extra = announcementHeight === 0 ? 24 : 34;
  const totalHeight = announcementHeight + headerHeight + drawerHeight + extra;

  // console.log({
  //   announcementHeight,
  //   headerHeight,
  //   drawerHeight,
  //   totalHeight, extra
  // });

  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  document.documentElement.style.setProperty('--total-header-height', `${totalHeight}px`);
}

// Helper: element visible in viewport (for announcement)
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.bottom > 0;
}

/* ===== EVENTS ===== */
window.addEventListener('load', updateHeaderHeight);
window.addEventListener('scroll', updateHeaderHeight);
window.addEventListener('resize', updateHeaderHeight);

document.addEventListener('click', () => {
  setTimeout(updateHeaderHeight, 200);
});
document.querySelector('.new_drawer_layout')?.addEventListener('transitionend', () => {
  setTimeout(updateHeaderHeight, 50);
});


  //==============================================================

      
  function swymCallbackFn(swat) {
    document.addEventListener("swym:collections-loaded", function () {
      swat.initializeActionButtons("body");
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swymCallbackFn);

  const input = document.querySelector('#search-drawer-input');
  const predictiveSearch = document.querySelector('#predictive-search');

  if (!input || !predictiveSearch) return;

  const observer = new MutationObserver(() => {
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  });
  observer.observe(predictiveSearch, { childList: true, subtree: true });

  input.addEventListener('input', () => {
    const hasText = input.value.trim().length > 0;
    if (hasText) {
      predictiveSearch.classList.add('predictive_search');
    } else {
      predictiveSearch.classList.remove('predictive_search');
    }
  });




  // =========================================================


  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const menu = document.querySelector('.mobile-menu');
  const drawer = document.querySelector('.mobile_menu_drawer');
  const mobileSubmenu = document.querySelector('.mobile-submenu');

  // Toggle entire mobile menu
  if (menuToggle && menu) {
    menuToggle.addEventListener('click', () => {
      menu.classList.toggle('active');
    });
  }

  // Toggle each parent group open/close
  const groupToggles = document.querySelectorAll('.menu-group-toggle');
  groupToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const parent = toggle.closest('.menu-group');
      const submenu = parent.querySelector('.submenu-list');

      document.querySelectorAll('.menu-group.open').forEach(openGroup => {
        if (openGroup !== parent) {
          openGroup.classList.remove('open');
        }
      });

      // Toggle current menu open/close
      const isOpen = parent.classList.toggle('open');

      if (drawer) {     
        if (isOpen) {
          drawer.classList.add('active');
          document.body.classList.add('menu-hover-active');
          let submenuHeight = 0;
          if (submenu) submenuHeight += submenu.scrollHeight;
          if (mobileSubmenu) submenuHeight += mobileSubmenu.scrollHeight + 10;

          drawer.style.setProperty('--drawer-content-height', submenuHeight + 'px');
        } else {
          drawer.classList.remove('active');
          // document.body.classList.remove('menu-hover-active');
          drawer.style.setProperty('--drawer-content-height', 'auto');
        }
      }
    });
  });


  // ==================== collection page  layout ========================
  document.querySelectorAll('input[name="desktop-layout"]').forEach(radio => {
    radio.addEventListener('change', function () {
      const layout = this.value;
  
      console.log("layout", layout);
      if (layout === "list") {
          $('.original_product_card').addClass('hidden');
          $('.product-card_list').removeClass('hide-desktop');
          $('.original_product_card').addClass('hide-desktop');
      }
      else{
         $('.original_product_card').removeClass('hidden');
          $('.product-card_list').addClass('hide-desktop');
          $('.original_product_card').removeClass('hide-desktop');
      }

    });
  });

  document.querySelectorAll('input[name="mobile-items-per-row"]').forEach(radio => {
    radio.addEventListener('change', function () {
      const layout = this.value;
      console.log("Selected layout:", layout);

      // Example actions:
      if (layout === "4") {
          $('.original_product_card').addClass('hide-mobile');
          $('.product-card_list').removeClass('hide-mobile');
      }
      else{
         $('.original_product_card').removeClass('hide-mobile');
          $('.product-card_list').addClass('hide-mobile');
      }
      
    });
  });


});


// ===============================================

// const hoverElements = document.querySelectorAll('.header__primary-nav a.block.subheading');

// hoverElements.forEach(el => {
//   el.addEventListener('mouseenter', () => {
//     document.body.classList.add('hover-active');
//   });

//   el.addEventListener('mouseleave', () => {
//     document.body.classList.remove('hover-active');
//   });
// });




